import React, { useContext } from 'react';
import './job-card.scss';
import { StateContext } from '../state/contexts';
import JobImage from './components/job-image';
import JobCardProperties from './types/jobCardProperties';
import { JobFlagNew } from './components/job-properties-list';
import JobPropertiesListSortable from './components/job-properties-list-sortable';

const JobCard = ({ job, className, withImage = false }: JobCardProperties) => {
  const state = useContext(StateContext);
  const { config } = state;
  const { linkTarget } = config.config.ui;

  return (
    <a
      href={job.jobPublicationURL}
      target={linkTarget}
      className={`dvinci-job-entry card ${typeof className === 'undefined' ? '' : className}`}
    >
      <JobImage job={job} withImage={withImage} />
      <JobFlagNew job={job} />
      <div className="card-body">
        <h3 className="dvinci-job-position">
          {job.position}
          {job.subtitle && <small className="dvinci-job-subtitle">{job.subtitle}</small>}
        </h3>
        <JobPropertiesListSortable job={job} />
      </div>
    </a>
  );
};

export default JobCard;
